<template>
  <div>
    <a-table
      :columns="AppointColumns"
      :transformCellText="({ text }) => text ?? '--'"
      :pagination="false"
      :data-source="TableData"
      rowKey="id"
      :scroll="{ x: '100%', y: 'calc(100vh - 330px)' }"
    >
      <template #reserveDate="{ text: reserveDate }">
        <span>
          {{ handleTimeShowWeek(reserveDate) || '--' }}
        </span>
      </template>
      <template #revisitType="{ text: revisitType }">
        <span>
          {{ ['线上问诊', '门诊就诊'][revisitType - 1] || '无' }}
        </span>
      </template>
      <template #reserveState="{ text: reserveState }">
        <span>
          {{ Config.RESERCE_STATE_MAP[Number(reserveState)] || '无' }}
        </span>
      </template>
      <template #operation="{ record }">
        <a @click="rowDetail(record)">查看详情</a>
      </template>
    </a-table>
    <ADetail ref="aDetail" :recordId="appointId" />
  </div>
</template>
<script setup>
import ADetail from '@/views/WorkPlace/components/Appoint/index.vue'
import { handleTimeShowWeek } from '@/utils'
import { AppointColumns } from './config.js'
import { nextTick, ref, defineProps, onMounted } from 'vue'
import { appointRecordIdApi } from '@/api/workPlace/appoint'
import Config from '@/config/index'

const aDetail = ref(null)
const TableData = ref([])
const props = defineProps({
  cureReserveId: {
    type: Number,
    default: null
  }
})
const appointId = ref('')
const rowDetail = row => {
  appointId.value = row.id.toString()
  nextTick(() => {
    aDetail.value.mVisible = true
    aDetail.value.initDetail()
  })
}
const listquery = async () => {
  TableData.value.splice(0)
  if (!props.cureReserveId) return
  const res = await appointRecordIdApi({ reserveId: props.cureReserveId })
  TableData.value = [res]
}
onMounted(() => {
  listquery()
})
</script>
<style lang="scss" scoped>
.footer {
  margin-top: 20px;
}
</style>
